<template>
  <header class="site-header empty-nav">
    <div class="empty-nav__main-navigation">
      <NavLogo
        class="empty-nav__logo"
        :homepageUrl="homepageUrl"
        :theme="THEMES.black"
        :variant="isMobile ? VARIANTS.mobile : VARIANTS.desktop"
      ></NavLogo>
      <Button
        class="empty-nav__button"
        :tag="'a'"
        :href="homepageUrl"
        :height="BUTTON_STYLES.height.normal"
      >
        {{ $t('back_to_home') }}
      </Button>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import NavLogo, { VARIANTS, THEMES } from '@/components/Navigation/NavLogo/NavLogo.vue'
import Button, { BUTTON_STYLES } from '@/components/_shared/Button.vue'

export default {
  name: 'EmptyNav',
  components: {
    NavLogo,
    Button,
  },

  data() {
    return { VARIANTS, THEMES, BUTTON_STYLES }
  },

  computed: {
    ...mapGetters({
      homepageUrl: 'page/homepageUrl',
      isMqLarger: 'viewport/isMqLarger',
    }),

    isMobile() {
      return !this.isMqLarger
    },
  },
}
</script>

<style scoped lang="scss">
.empty-nav {
  z-index: 3;
  position: absolute;
  background: $color-white;
  padding: 0;

  @media ($mq-larger) {
    padding: 0 40px 0 15px;
  }

  &__main-navigation {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: $navigation-z-index - 1;
  }

  &__logo {
    position: relative;
    left: auto;
    transform: none;
  }

  &__button {
    display: none;
    width: auto;
    height: 48px;
    padding: 15px 24px 16px;
    color: $color-black;
    background: none;
    border: 1px solid $color-black;
    border-radius: 40px;

    @media ($mq-larger) {
      display: flex;
      align-items: center;
    }

    &:hover,
    &:focus {
      background-color: $color-grey-light-1;
    }
  }
}
</style>

<i18n src="@/locales/empty_nav.json">
</i18n>
